import { useEffect, useRef } from 'react'
import { track } from 'lib/amplitude'
import { useAuthContext } from 'components/auth'
import { useShiftEditor } from './useShiftEditor'

type OnDemandDeliveryPageName = 'Details' | 'Dates' | 'Team' | 'Pay' | 'Review'

export const useTrackOnDemandDeliveryPageView = (
  pageName: OnDemandDeliveryPageName
) => {
  const { isOnDemandDeliveryBlock } = useShiftEditor()
  const { company } = useAuthContext()
  const companyId = company?.id
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    if (!isOnDemandDeliveryBlock || !companyId || hasTrackedRef.current) {
      return
    }
    hasTrackedRef.current = true
    track(`impression, ShiftEditor_OnDemandDelivery${pageName}_page`, {
      companyId,
    })
  }, [isOnDemandDeliveryBlock, pageName, companyId])
}
